module.exports = __webpack_public_path__ + "static/media/zhiyu_chinese_mandarian.94764b02.mp3";